// extracted by mini-css-extract-plugin
export default {"swiper__wrapper":"swiperSlider_swiper__wrapper__ErTFg","image":"swiperSlider_image__r82RD","box":"swiperSlider_box__XTdGM"};